import { amplitudeEvent } from '@api/amplitude';
import { fullStoryEvent } from '@api/fullStory';


export function trackEventToAll(eventName, props = {}) {
    amplitudeEvent(eventName, props);
    fullStoryEvent(eventName, props);
}

export {amplitudeEvent, fullStoryEvent};